<h1 mat-dialog-title class="cls-modal-block-title">
    <div class="cls-icon-krest1">
        <mat-icon svgIcon="close-dialog" [mat-dialog-close]="true"></mat-icon>
    </div>

    <!--
  <span class="cls-modal-block-header">Описание посещения пациента</span>
--></h1>

<div mat-dialog-content>
    <div *ngIf="isLoading">
        <loader type="page" message="Загружаем протокол ..."></loader>
    </div>
    <div [innerHTML]="resHtml" *ngIf="!isLoading"></div>
    <div *ngIf="link && !isLoading" class="result_pdf">
        Просмотреть
        <button
            class="result-item"
            (click)="gotToDownload(link, $event)"
        >
            <img
                *ngIf="!pdfLoading"
                class="result-item__img"
                [src]="pdfImageURL"
            />
            <img
                *ngIf="pdfLoading"
                class="loader-rotate"
                src="./assets/icons/actions/loading-button.svg"
            />
        </button>
    </div>
    <div class="btn_close" *ngIf="!isLoading">
        <button class="btn btn-dialog-close" [mat-dialog-close]="true">
            Закрыть
        </button>
    </div>
</div>
